export function handleScrollToForm(vm,s) {
    // console.log(vm)
    // console.log(s)
    vm.$nextTick(() => {
        const formElement = vm.$refs[s]?.$el
        if (!formElement) {
            // console.warn('表单元素未找到')
            return
        }

        // 获取 HeaderBar 高度
        const header = document.querySelector("#headerBarElement")
        const headerHeight = header ? header.offsetHeight : 0

        // 获取目标组件 offsetTop
        const targetOffsetTop = formElement.offsetTop

        // 计算目标滚动位置
        const targetScrollTop = targetOffsetTop - headerHeight

        window.scrollTo({
            top: targetScrollTop,
            behavior: 'auto'
        });
        // 获取当前滚动位置
        /*const startPosition = window.scrollY
        const distance = targetScrollTop - startPosition
        let startTime = null

        // 动画函数
        const easeInOutQuad = (t, b, c, d) => {
            t /= d / 2
            if (t < 1) return (c / 2) * t * t + b
            t--
            return -c / 2 * (t * (t - 2) - 1) + b
        }

        const animation = (currentTime) => {
            if (!startTime) startTime = currentTime
            const timeElapsed = currentTime - startTime
            const run = easeInOutQuad(timeElapsed, startPosition, distance, 1000)
            window.scrollTo(0, run)
            if (timeElapsed < 1000) requestAnimationFrame(animation)
        }

        requestAnimationFrame(animation)*/
    })
}